import DigitalPlatformMobile from './DigitalPlatformMobile';

export default DigitalPlatformMobile;
